export default {
  public: [
    {
      path: '/series/:id/:ep?',
      name: 'series-detail',
      component: () => import('modules/video/views/public/seriesDetailNew.vue'),
    },
    {
      path: '/video/:id',
      name: 'video-detail',
      component: () => import('modules/video/views/public/seriesDetailNew.vue'),
    },
    {
      path: '/live',
      name: 'live',
      component: () => import('modules/video/views/public/live.vue'),
    },
  ],
  unauthorizedAdmin: [],
  admin: [
    {
      path: 'video',
      name: 'admin.video-list',
      component: () => import('modules/video/views/admin/videoList.vue'),
    },
    // {
    //   path: 'video/create',
    //   name: 'admin.video-create',
    //   meta: {
    //     mode: 'create',
    //   },
    //   component: () => import('modules/video/views/admin/videoForm.vue'),
    // },
    {
      path: 'video/edit/step-:step/:id',
      name: 'admin.video-edit',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/video/views/admin/videoEditPage.vue'),
    },

    {
      path: 'video/update/:id',
      name: 'admin.video-update',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/video/views/admin/videoForm.vue'),
    },

    // 影集分類
    {
      path: 'series-category-tree',
      name: 'admin.series-category-tree',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/video/views/admin/seriesCategoryTree.vue'),
    },

    {
      path: 'series',
      name: 'admin.series-list',
      component: () => import('modules/video/views/admin/seriesList.vue'),
    },
    // {
    //   path: 'series/create',
    //   name: 'admin.series-create',
    //   meta: {
    //     mode: 'create',
    //   },
    //   component: () => import('modules/video/views/admin/seriesForm.vue'),
    // },
    {
      path: 'series/update/:id',
      name: 'admin.series-update',
      meta: {
        mode: 'update',
      },
      component: () => import('modules/video/views/admin/seriesForm.vue'),
    },
    // 影片側錄-常用設定
    {
      path: 'program-config',
      name: 'admin.program-config-list',
      component: () => import('modules/video/views/admin/programConfigList.vue'),
    },
    // {
    //   path: 'program-config/create',
    //   name: 'admin.program-config-create',
    //   meta: {
    //     mode: 'create',
    //   },
    //   component: () => import('modules/video/views/admin/programConfigForm.vue'),
    // },
    // {
    //   path: 'program-config/update/:id',
    //   name: 'admin.program-config-update',
    //   meta: {
    //     mode: 'update',
    //   },
    //   component: () => import('modules/video/views/admin/programConfigForm.vue'),
    // },

    // 節目表
    {
      path: 'program',
      name: 'admin.program',
      component: () => import('modules/video/views/admin/program.vue'),
    },

    // 影片預告
    {
      path: 'video-preview',
      name: 'admin.video-preview-list',
      component: () => import('modules/video/views/admin/videoPreviewList.vue'),
    },
  ],
}